import * as React from 'react';
import {FunctionComponent} from 'react';
import {MainTable} from './Widgets/MainTable';
import Modal from '../../../Components/Modal';
import {TrendTemplateForm} from './Forms/TrendTemplateForm';
import {ReportTemplate, TrendTemplate} from './Models/ReportTemplate';
import {ReportData} from './TrendReportPresenter';
import {TemplateCards} from './TemplateCards';
import {classNames} from '../../../Support/classNames';
import {toJS} from 'mobx';

interface OwnProps {
    template: ReportTemplate;
    isLocked: boolean;
    startAddingTrend: () => void;
    selectedSnippetIds: number[];
    highlightedSnippetIds: number[];
    reportData: ReportData;
    updateSelectedSnippetIds: (selectedSnippetIds: number[]) => void;
    updateHighlightedSnippetIds: (highlightedSnippetIds: number[]) => void;
    onDeleteSnippet: (selectedSnippetIds: number) => void;
    updateTrendTemplate: (index: number, trendTemplate: TrendTemplate) => void;
    deleteTrendTemplate: (index: number) => void;
    addTrendTemplate: (trendTemplate: TrendTemplate) => void;
    adding: boolean;
    stopAddingTrend: () => void;
}

export const TrendReportContent: FunctionComponent<OwnProps> = ({
    template,
    isLocked,
    startAddingTrend,
    selectedSnippetIds,
    highlightedSnippetIds,
    reportData,
    updateSelectedSnippetIds,
    updateHighlightedSnippetIds,
    onDeleteSnippet,
    updateTrendTemplate,
    deleteTrendTemplate,
    addTrendTemplate,
    adding,
    stopAddingTrend,
}) => {
    return (
        <>
            {template.trends.length === 0 && (
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <span
                                className={classNames('workoutlist__empty', {
                                    'workoutlist__empty--compact': !isLocked,
                                })}
                            >
                                <span className="workoutlist__empty_image" />
                                <span className="workoutlist__empty_text">
                                    <p>No template</p>
                                    <small>
                                        You have added your first workouts to this report! Now let's configure exactly
                                        the metrics we want to track. Choose one of our templates or create your own.
                                    </small>

                                    {isLocked && (
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <p>
                                                    You have locked an empty report, please unlock the report before
                                                    adding trends.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </span>
                            </span>
                        </div>
                    </div>
                    {!isLocked && (
                        <TemplateCards startAddingTrend={startAddingTrend} addTrendTemplate={addTrendTemplate} />
                    )}
                </div>
            )}
            {template.trends.map((trend, index) => {
                return (
                    <MainTable
                        key={index}
                        className="mb-3"
                        reportData={reportData}
                        index={index}
                        template={trend}
                        isLocked={isLocked}
                        selectedSnippetIds={selectedSnippetIds}
                        highlightedSnippetIds={highlightedSnippetIds}
                        onChangeSelectedSnippetIds={(snippetIds) => {
                            updateSelectedSnippetIds(snippetIds);
                        }}
                        onChangeHighlightedSnippetIds={(snippetIds) => {
                            updateHighlightedSnippetIds(snippetIds);
                        }}
                        onDeleteSnippet={(snippetId) => {
                            onDeleteSnippet(snippetId);
                        }}
                        onChange={(trendTemplate) => {
                            updateTrendTemplate(index, trendTemplate);
                        }}
                        onDelete={() => {
                            deleteTrendTemplate(index);
                        }}
                    />
                );
            })}
            {template.trends.length > 0 && !isLocked && (
                <div className="row">
                    <div className="col-12">
                        <button className="btn btn-wide btn-primary btn-lg" onClick={() => startAddingTrend()}>
                            Add
                        </button>
                    </div>
                </div>
            )}
            <Modal visible={adding} wide onHide={() => stopAddingTrend()}>
                <TrendTemplateForm
                    isAdding
                    suggestTemplates={template.trends.length > 0}
                    onFinish={(newTrendTemplate) => {
                        addTrendTemplate(newTrendTemplate);
                    }}
                    onDelete={() => {
                        stopAddingTrend();
                    }}
                    onCancel={() => stopAddingTrend()}
                />
            </Modal>
        </>
    );
};
